import MsLogin from "./MsLogin";

function MsLoginWrapper() {
  return <MsLogin />;
}

export default MsLoginWrapper;
